
import QrcodeVue from 'qrcode.vue'
import { defineComponent, onMounted, onBeforeUnmount, reactive } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { AccountManageLoginService } from './loginApi.service'
import { VERIFICATION_STATUS } from '../constants'

/** 账号验证二维码组件 */
export default defineComponent({
  name: 'AccountQrcodeVerification',
  components: {
    QrcodeVue
  },
  props: {
    size: {
      type: Number,
      default: 110
    }
  },
  emits: ['success', 'error'],
  setup(_, { emit }) {
    let isDestroy = false // 用于劫持异步
    const injector = useReflectiveInjector([AccountManageLoginService])
    const service = injector.get(AccountManageLoginService)

    const viewModel = reactive({
      qrText: '',
      retry: false,
      verify_ticket: '',
      loopTimer: null as any,
      expiryTimer: null as any,
      loopFollowTime: 1000,
    })

    onMounted(() => loadVerificationQrCode())

    onBeforeUnmount(() => {
      isDestroy = true
      clearExpiryTimer()
      clearLoopIsFollow()
    })

    /**
     * @description 加载验证二维码
     */
    function loadVerificationQrCode() {
      service.requestGetWXCode().then(res => {
        if (isDestroy) {
          return
        }

        if (!res.qrcode_url) {
          viewModel.retry = true
          emit('error', '获取二维码失败')
          return
        }

        viewModel.retry = false
        viewModel.qrText = res.qrcode_url
        viewModel.verify_ticket = res.verify_ticket

        loopIsFollow()
        expireReloadQrcode(res.expire_seconds)
      }).catch((err) => {
        qrRetry()
        emit('error', err)
      })
    }

    /**
     * @description 过期重新加载二维码
     */
    function expireReloadQrcode(wait: number) {
      clearExpiryTimer()
      viewModel.expiryTimer = setTimeout(() => qrRetry(), wait * 1000)
    }

    /**
     * @description 启动是否关注公众号轮询
     */
    function loopIsFollow() {
      clearLoopIsFollow()
      isFollowOfficial()
    }

    /**
     * @description 清除是否关注公众号定时器标识
     */
    function clearLoopIsFollow() {
      clearTimeout(viewModel.loopTimer)
    }

    /**
     * @description 清除二维码过期定时器标识
     */
    function clearExpiryTimer() {
      clearTimeout(viewModel.expiryTimer)
    }

    /**
     * @description 二维码错误
     */
    function qrRetry() {
      viewModel.retry = true
      clearLoopIsFollow()
    }

    /**
     * 检查微信扫码验证状态
     */
    function isFollowOfficial() {
      const params = {
        verify_ticket: viewModel.verify_ticket
      }

      service.requestGetTokenWX(params).then(res => {
        if (res.status === VERIFICATION_STATUS.SUCCESS) {
          // 验证成功
          clearLoopIsFollow()
          clearExpiryTimer()
          // 验证成功，返回 close_token 给父组件
          emit('success', res.close_token)
          return
        }
        if (res.status === VERIFICATION_STATUS.FAILED) {
          // 验证失败
          clearLoopIsFollow()
          clearExpiryTimer()
          emit('error', res.message || '验证失败')
          return
        }

        // 等待中，延迟后继续轮询
        viewModel.loopTimer = setTimeout(() => isFollowOfficial(), viewModel.loopFollowTime)
      }).catch(err => {
        emit('error', err)
      })
    }

    return {
      viewModel,
      loadVerificationQrCode
    }
  }
})
